import { render } from "./InviteGroup.vue?vue&type=template&id=0b4e0a06&scoped=true"
import script from "./InviteGroup.vue?vue&type=script&lang=js"
export * from "./InviteGroup.vue?vue&type=script&lang=js"

import "./InviteGroup.vue?vue&type=style&index=0&id=0b4e0a06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4e0a06"]])

export default __exports__